<template>
    <v-container>
        <v-row justify="start" >
            <v-col cols="12">
                <v-card >
                    <v-card-title>
                        <v-col><h1>Query log</h1></v-col>
                    </v-card-title>
                    <v-card-title>
                        <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table :headers="dataHeaders" :items="dataList" :search="search" scroll class="elevation-1">
                        <template v-slot:item.index="{ item }">
                            {{dataList.findIndex(items => { return items.id == item.id})+1}}
                        </template>
                        <template v-slot:item.query_at="{ item }">
                            <span v-if="item.query_at != null">{{ item.query_at | moment}}</span>
                            <span v-if="item.query_at == '' || item.query_at == null"> - </span>
                        </template>
                        <template v-slot:item.name="{item}">
                            <p class="mt-5">{{ item.name }}</p>
                        </template>
                        <template v-slot:item.sensor="{item}">
                            <a >
                            <span @click="toSensor(item)">{{ item.sensor}}</span> 
                            </a>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import moment from 'moment'
import axios from 'axios'
var host_url = process.env.VUE_APP_HOST_URL

export default {
    filters: {
        moment: function (date) {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }
    },
    data(){
        return {
           
            // 查詢
            search: '',
            
            // 查詢使用Sensor參數
            checkDialog: false,
            //  使用者名稱
            name: 'Artilux',
            //  使用者參數
            dataHeaders: [
                {text: 'No.', align: 'start', value: 'index', width: 60, class: 'pa-3'},
                {text: 'Query time', align: 'start', value: 'query_at', width: 170, class: 'pa-3'},                
                {text: 'Account', align: 'start', value: 'account', width: 100, class: 'pa-3'},                
                {text: 'Company', align: 'start', value: 'name', width: 100, class: 'pa-3'},                
                {text: 'Sensor model', align: 'start', value: 'sensor', width: 120},
                {text: 'Laser peak power (W)', align: 'start', value: 'laser_peak_power_w', width: 150},
                {text: 'Tx relative illumination', align: 'start', value: 'tx_relative_illum', width: 180},
                {text: 'Object reflectivity (%)', align: 'start', value: 'object_reflectivity_percent', width: 180},
                {text: 'Solar ambient light (Lux)', align: 'start', value: 'solar_ambient_lux', width: 180},
                {text: 'Lens transmittance (%)', align: 'start', value: 'lens_transmittance_percent', width: 180},
                {text: 'Lens field of view (degree)', align: 'start', value: 'lens_field_of_view_deg', width: 180},
                {text: 'Lens focal number', align: 'start', value: 'lens_focal_number', width: 180},
                {text: 'Lens focal length (mm)', align: 'start', value: 'lens_focal_length_mm', width: 180},
                {text: 'Rx relaive illumination', align: 'start', value: 'rx_relative_illum', width: 180},
                {text: 'Bandpass filter transmittance (%)', align: 'start', value: 'bandpass_transmittance_percent', width: 210},
                {text: 'Bandpass filter wavelength lower bound (nm)', align: 'start', value: 'bandpass_lower_nm', width: 280},
                {text: 'Bandpass filter wavelength upper bound (nm)', align: 'start', value: 'bandpass_upper_nm', width: 280},
                {text: 'Demodulation Frequency (MHz)', align: 'start', value: 'demod_frequency_mhz', width: 210},
                {text: 'Exposure time per quad per subframe (us)', align: 'start', value: 'exposure_time_per_quad_per_subframe_us', width: 270},
                {text: 'Subframe number (#)', align: 'start', value: 'subframe_number', width: 180},
                {text: 'Capacitance', align: 'start', value: 'capacitance_fF', width: 180},
                {text: 'Temperature (°C)', align: 'start', value: 'temperature_C', width: 150},
                {text: 'Depth error unit', align: 'start', value: 'depth_error_unit', width: 120},
                {text: 'Range (m)', align: 'start', value: 'range_m', width: 100},
                {text: 'Error message', align: 'start', value: 'error_message', width: 150},
            ],
            dataList: [],
        }
    },
    created(){
        this.get_params()
        let check_search = this.$route.query.params
        if(check_search){
            this.search = check_search
        }
    },
    methods:{
        checkParams(){
            // console.log('in check')
            this.checkDialog = !this.checkDialog
        },
        get_params(){
            axios.get(host_url+'itof/get_param/')
            .then(response => {
                let tmp = response.data
                if(tmp.status == true){
                    this.dataList = tmp.data     
                }
            })
        },
        toSensor(item){
            this.$router.push({ path: '/sensor_model_overview', query: {params: item.sensor}})
        },
        
    }
}
</script>
<style scoped>
.borderStyle {
  border: 1px lightgray solid;
  margin-top: 3px;
  border-radius: 10px;
  padding: 5px;
  
}
.textStyle{
    align-items: 'right';
}
</style>